import Vue from 'vue';

Vue.filter('eventDisplayName', value => {
  let output;
  
  // use custom formatting
  if (/^(fusion).*/i.test(value)) {
    output = value.replace(/-/g, ' ').toUpperCase();
  } else {
    output = value.toUpperCase();
  }

  return output;
});